import { ArrowRight, ImagePlus, Loader2 } from "lucide-react";
import type { ProfileStepProps } from "./welcome-onboarding-types";

export function WelcomeProfileStep({
  busy,
  fileRef,
  isBusy,
  onAvatar,
  onSubmit,
  onUpdate,
  profile,
}: ProfileStepProps) {
  return (
    <form
      className="welcome-onboarding__panel"
      onSubmit={onSubmit}
      aria-label="Trader profile"
    >
      <button
        className="welcome-onboarding__avatar"
        onClick={() => fileRef.current?.click()}
        type="button"
        title="Choose profile image"
      >
        {profile.avatarUrl ? (
          <img src={profile.avatarUrl} alt="" />
        ) : (
          <ImagePlus size={20} strokeWidth={1.8} />
        )}
      </button>
      <input
        ref={fileRef}
        className="welcome-onboarding__file"
        type="file"
        accept="image/*"
        onChange={(event) => onAvatar(event.target.files?.[0] ?? null)}
      />

      <div className="welcome-onboarding__fields">
        <label>
          <span>Trader name tag</span>
          <input
            value={profile.nameTag}
            onChange={(event) => onUpdate("nameTag", event.target.value)}
            placeholder="TP"
          />
        </label>
        <label>
          <span>Broker or prop firm</span>
          <input
            value={profile.brokerOrPropFirm}
            onChange={(event) =>
              onUpdate("brokerOrPropFirm", event.target.value)
            }
            placeholder="Optional"
          />
        </label>
        <label>
          <span>Billing tier</span>
          <input readOnly value="Consul beta" />
        </label>
      </div>

      <button
        className="welcome-onboarding__btn welcome-onboarding__btn--primary"
        disabled={isBusy}
        type="submit"
      >
        {busy === "saving" ? (
          <Loader2 size={16} strokeWidth={2.1} className="spin" />
        ) : (
          <ArrowRight size={17} strokeWidth={2.1} />
        )}
        <span>Continue</span>
      </button>
    </form>
  );
}
